<template>
  <v-card outlined class="ma-2">
    <v-card-title class="subtitle-1">
      Penalizare #{{index + 1}}
      <v-spacer/>
      <v-btn depressed color="error" class="ma-n1" @click="$emit('remove', rule)">
        <v-icon>mdi-delete</v-icon>
      </v-btn>
    </v-card-title>
    <v-divider class="mx-2"/>
    <v-card-text class="pa-2">
      <v-row no-gutters>

        <v-col cols="12">
          <div class="ma-1">
            Dacă rezervarea este modificată înaite de check-in cu:
          </div>
        </v-col>

        <v-col cols="6">
          <v-text-field
            class="ma-1"
            v-model="rule.interval_value"
            label="Valoare"
            type="number"
            outlined dense hide-details
          />
        </v-col>

        <v-col cols="6">
          <v-select
            class="ma-1"
            v-model="rule.interval_type"
            :items="formula.interval_types"
            label="Tip Interval"
            outlined dense hide-details
          />
        </v-col>

        <v-col cols="12">
          <div class="ma-1">
          Se aplică o penalizare de:
          </div>
        </v-col>

        <v-col cols="6">
          <v-text-field
            class="ma-1"
            v-model="rule.penalty_value"
            label="Valoare"
            type="number"
            outlined dense hide-details
          />
        </v-col>

        <v-col cols="6">
          <v-select
            class="ma-1"
            v-model="rule.penalty_type"
            :items="formula.penalty_types"
            label="Tip Penalizare"
            outlined dense hide-details
          />
        </v-col>
      </v-row>
    </v-card-text>
  </v-card>
</template>

<script>
  import conf_repository from "@/repositories/config-repository";

  export default {

    props: {
      index: Number,
      rule: Object
    },

    data: () => ({
      formula: {
        penalty_types: null,
        interval_types: null
      },
    }),

    async created() {
      this.formula = await conf_repository.getCancellationPolicyFormula();
    }

  }
</script>